rdefine('app/formular/components/TabHeadItem',['backbone','text!formular/tabhead.html'],function(Backbone,template) {
    return Backbone.Ribs.View.extend({
        tagName:'li',
        bindings:{
            el:{
                classes:{
                    active:'model.active'
                }
            },
            a:{
                text:'model.title'
            }
        },
        events:{
            "click a":"onClick"
        },
        initialize:function(options) {
            this.$el.html(template);
        },
        onClick:function(){
            this.collection.trigger("setactive",this.model);
            return false;
        }
    });
});

rdefine('app/formular/components/TabBody',['backbone'],function(Backbone) {
    return Backbone.Ribs.View.extend({
        tagName:'div',
        className:'tab-pane',
        bindings:{
            el:{
                classes:{
                    active:'model.active'
                }
            }
        },
        initialize:function(options) {
            var module=this.model.get("module");
            if(!module) {
                this.$el.text("Not found module");
                return;
            }
            this.component=new module(_.extend(this.model.get("options")));
            if(!this.component) {
                this.$el.text("Error initialize components");
                return;
            }
            this.$el.append(this.component.el);

        }
    });
});

rdefine('app/formular/components/Tabs',['backbone','app/formular/components/TabHeadItem','text!formular/tabs.html','app/formular/collections/TabsCollection','app/formular/components/TabBody'],function(Backbone,TabHead,template,TabsCollection,TabBody) {
    return Backbone.Ribs.View.extend({
        tagName:'div',
        collection:null,
        bindings:{
            ".tab-nav":{
                collection:{
                    view:TabHead,
                    col:'collection'
                }
            },
            ".tab-content":{
                collection:{
                    view:TabBody,
                    col:'collection'
                }
            }
        },
        initialize:function(options){
            this.collection=new TabsCollection();
            this.collection.reset((options && options.tabs) ? options.tabs: []);
            if(this.collection.length) {
                this.collection.models[0].set("active",true);
            }
            this.$el.html(template);
        }
    });
});